/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { IOnboardingReducer } from './onboardingReducer';
import { EOnboardingPage, EOnboardingStatus } from './types/onboardingTypes';

export const ONBOARDING_DATA_ATTR = 'data-onboarding';

export const initialOnboardingState: IOnboardingReducer = {
    isDisplayedByUser: false,
    isOnboardingExists: false,
    isWelcomeOnboardingCompleted: false,
    page: EOnboardingPage.dashboard,
    status: EOnboardingStatus.init,
    stepsIds: [],
};

/*
* -------------------------------------------
*           ONBOARDING ACTIONS
* -------------------------------------------
*/

export const ONBOARDING_INIT_START = '@@b2b_portal_ui/onboarding/ONBOARDING_INIT_START';
export const ONBOARDING_INIT_SUCCESS = '@@b2b_portal_ui/onboarding/ONBOARDING_INIT_SUCCESS';

export const ONBOARDING_PAGE_READY_FOR_START = '@@b2b_portal_ui/onboarding/ONBOARDING_PAGE_READY_FOR_START';

export const ONBOARDING_START = '@@b2b_portal_ui/onboarding/ONBOARDING_START';

export const ONBOARDING_SKIP = '@@b2b_portal_ui/onboarding/ONBOARDING_SKIP';

export const ONBOARDING_FINISH = '@@b2b_portal_ui/onboarding/ONBOARDING_FINISH';

export const ONBOARDING_SHOW_LATER = '@@b2b_portal_ui/onboarding/ONBOARDING_SHOW_LATER';

export const ONBOARDING_NEXT_STEP = '@@b2b_portal_ui/onboarding/ONBOARDING_NEXT_STEP';

export const ONBOARDING_SET_CURRENT_STEP = '@@b2b_portal_ui/onboarding/ONBOARDING_SET_CURRENT_STEP';

export const ONBOARDING_MODAL_VIEWED = '@@b2b_portal_ui/onboarding/ONBOARDING_MODAL_VIEWED';


export const ONBOARDING_ENABLE = '@@b2b_portal_ui/onboarding/ONBOARDING_ENABLE';
export const ONBOARDING_DISABLE = '@@b2b_portal_ui/onboarding/ONBOARDING_DISABLE';

export const ONBOARDING_DISABLE_ALL = '@@b2b_portal_ui/onboarding/ONBOARDING_DISABLE_ALL';
